import { RemoteGetSmartcardsByStatus } from "../../../../data/usecases/smartcard/remote-get-smartcards-by-status";
import { GetSmartcardsByStatus } from "../../../../domain/usecases/get-smartcards-by-status";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteGetSmartcardsByStatus = (): GetSmartcardsByStatus =>
  new RemoteGetSmartcardsByStatus(
    makeApiUrl("/smartcards/get-smartcards-by-status"),
    makeAxiosHttpClient()
  );
